/*
 * @Descripttion:
 * @Author: Junteng Shi
 * @Date: 2025-03-06 14:58:24
 * @LastEditors: HongJian Liu
 * @LastEditTime: 2025-07-08 10:05:43
 */
import { createRouter, createWebHistory } from 'vue-router';
import routes from './root';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { isLogin, getToken } from '@/utils/auth';
import { addRoutes } from '@/utils/asyncRoute';
import { getSysMenusList } from '@/api/user';
import { useAppStore, useUserStore } from '@/store';

// 前置路由守卫，添加动态路由
let registerRouteFresh1 = true; //记录路由动态加载的状态
let registerRouteFresh2 = true;

const whiteList = ['/login']; // Login whitelist

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  NProgress.start();

  const appStore = useAppStore();
  const userStore = useUserStore();

  // if (isLogin()) {
  if (to.path == '/login') {
    console.log('router111');
    if (getToken()) {
      next({
        path: '/',
      });
      // router.push('/')
    } else {
      next();
    }
  } else {
    if (getToken()) {
      console.log('router222');

      if (from.path === '/login' && registerRouteFresh1) {
        console.log('此时没有路由');
        // fetchAndSetMenu(appStore, userStore)
        //   .then(() => {
        //     addRoutes(appStore, router);
        //     next({ ...to, replace: true });
        //     registerRouteFresh1 = false;
        //   })
        //   .catch((error) => {
        //     console.error('请求路由菜单失败', error);
        //     userStore.logout();
        //     next({ path: '/login' });
        //   });
        try {
          await fetchAndSetMenu(appStore, userStore);
          addRoutes(appStore, router);
          registerRouteFresh1 = false;
          next({ ...to, replace: true });
          return;
        } catch (error) {
          userStore.logout();
          next({ path: '/login' });
          return;
        }
      }
      // 本地刷新的时候执行
      // if (!from.name && registerRouteFresh2) {
      //   const appStore = useAppStore();
      //   addRoutes(appStore, router);
      //   next({ ...to, replace: true });
      //   console.log('刷新页面');
      //   console.log(router.getRoutes());
      //   registerRouteFresh2 = false;
      // } else {
      //   console.log('正常跳转', router.getRoutes(), to);
      //   next();
      // }
      if (!from.name && registerRouteFresh2) {
        addRoutes(appStore, router);
        registerRouteFresh2 = false;
        next({ ...to, replace: true });
        return;
      }
      next();
      // next()
    } else {
      if (whiteList.includes(to.path)) {
        next();
      } else {
        next({ path: '/login' });
      }
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});

const fetchAndSetMenu = async (appStore: ReturnType<typeof useAppStore>, userStore: ReturnType<typeof useUserStore>) => {
  try {
    const res = await getSysMenusList();
    if (!res.length) {
      ElMessage.error('请先配置菜单');
      // userStore.logout();
      throw new Error('权限菜单为空');
    }
    appStore.setInitMenus(res);
    userStore.info();
  } catch (error) {
    ElMessage.error('获取菜单失败');
    throw error;
  }
};

export default router;
